import { type QuestionData } from "../wizard/lib";

export const questionData: { [name: string]: QuestionData } = {
  "single select choices": {
    questions: [
      {
        allow_multiple: false,
        choices: [
          {
            label: "Shed",
            value: "I want to build a shed",
            color: "red",
            icon: "arrow-left",
          },
          {
            label: "Extension",
            value: "I want to extend my house",
            color: "green",
          },
          {
            label: "Pool",
            value: "I want to build a pool",
            color: "blue",
          },
          {
            label: "Fence",
            value: "I want to build a fence",
            color: "yellow",
          },
          {
            label: "Additional dwelling",
            value: "I want to add an additional dwelling",
          },
          {
            label: "Carport",
            value: "I want to build a carport",
          },
        ],
        text_field_lines: 3,
        text_field_placeholder: "Or describe your project in your own words",
      },
    ],
    question_title: "What are you planning to do?",
  },
  "Map, multiple questions": {
    image_url:
      "https://dev-mylot-be-media.s3.ap-southeast-4.amazonaws.com/public/filer_public/4f89e47e-c12f-4b5a-b438-dff7c98255d4_address_satellite_image_gst7ymc0am9uosktgtyvgst7ymc0am9uosexai9xoc50ytc2kqwmobktgmytaikzu5giudwj.png",
    image_url_title: "",
    questions: [
      {
        allow_multiple: false,
        choices: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
        ],
        question_text: "Is there only one house on the lot?",
      },
      {
        allow_multiple: false,
        choices: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
        ],
        question_text:
          "Are any of the trees within 15 metres of your proposed outdoor room?",
      },
    ],
    question_subtitle: "We've noticed a few structures and several trees.",
    question_title: "Looking at the lot...",
  },
  "multiple questions linked via dependency": {
    questions: [
      {
        allow_multiple: false,
        choices: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
        ],
        question_text: "Is there only one house on the lot?",
      },
      {
        allow_multiple: false,
        choices: [
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
        ],
        dependency: {
          depends_on_question: 0,
          depends_on_choice: 0,
        },
        question_text:
          "Are any of the trees within 15 metres of your proposed outdoor room?",
      },
    ],
    question_subtitle:
      "Any room equipped with a bathroom, kitchen and general living facilities is considered accommodation.",
    question_title: "Will the outdoor room be used for accommodation?",
  },
  "multiple choice question": {
    questions: [
      {
        allow_multiple: true,
        choices: [
          {
            label: "Shed",
            value: "I want to build a shed",
          },
          {
            label: "Extension",
            value: "I want to extend my house",
          },
          {
            label: "Pool",
            value: "I want to build a pool",
          },
          {
            label: "Fence",
            value: "I want to build a fence",
          },
          {
            label: "Additional dwelling",
            value: "I want to add an additional dwelling",
          },
          {
            label: "Carport",
            value: "I want to build a carport",
          },
        ],
        text_field_lines: 3,
        text_field_placeholder: "Or describe your project in your own words",
      },
    ],
    question_title: "What are you planning to do?",
  },
  "trees within the property boundary": {
    required: true,
    image_url:
      "https://prod-mylot-be-media.s3.ap-southeast-4.amazonaws.com/public/filer_public/e0bebeb2-46e0-42fd-89d5-49e336b82854_address_satellite_image_gst7ymc0am9uosktgtyvgst7ymc0am9uosexai9xoc50ytc2kqwmobktgmytaikzm5voubkf.png",
    questions: [
      {
        choices: [
          {
            icon: null,
            color: null,
            label: "Not removing or destroying trees",
            value: "I'm",
          },
          {
            icon: null,
            color: null,
            label: "Removing or destroying trees",
            value: "I'm",
          },
        ],
        dependency: null,
        question_text: "Are you removing or destroying any trees?",
        allow_multiple: false,
        join_text_with: null,
        text_field_lines: null,
        question_subtitle: null,
        text_field_placeholder: null,
      },
      {
        choices: [
          {
            icon: null,
            color: null,
            label: "Not lopping or pruning trees",
            value: "I'm",
          },
          {
            icon: null,
            color: null,
            label: "Lopping or pruning trees",
            value: "I'm",
          },
        ],
        dependency: null,
        question_text: "Are you lopping or pruning any trees?",
        allow_multiple: false,
        join_text_with: null,
        text_field_lines: null,
        question_subtitle: null,
        text_field_placeholder: null,
      },
      {
        choices: [
          {
            icon: null,
            color: null,
            label: "Not within 15m of a tree",
            value: "Works",
          },
          {
            icon: null,
            color: null,
            label: "Within 15m of a tree",
            value: "Works",
          },
        ],
        dependency: null,
        question_text: "Will your works be within 15m of a tree?",
        allow_multiple: false,
        join_text_with: null,
        text_field_lines: null,
        question_subtitle: null,
        text_field_placeholder: null,
      },
      {
        choices: [
          {
            icon: null,
            color: null,
            label: "Yes",
            value: "Works will alter the ground level",
          },
          {
            icon: null,
            color: null,
            label: "No",
            value: "Works will not alter the ground level",
          },
        ],
        dependency: [
          {
            depends_on_choice: 1,
            depends_on_question: 2,
          },
        ],
        question_text: "Will the works alter the ground level?",
        allow_multiple: false,
        join_text_with: null,
        text_field_lines: null,
        question_subtitle: null,
        text_field_placeholder: null,
      },
      {
        choices: [
          {
            icon: null,
            color: null,
            label: "Native",
            value: "The affected tree is",
          },
          {
            icon: null,
            color: null,
            label: "Exotic",
            value: "The affected tree is",
          },
          {
            icon: null,
            color: null,
            label: "Unsure",
            value: "I'm not sure if the affected tree is native or exotic -",
          },
        ],
        dependency: [
          {
            depends_on_choice: 1,
            depends_on_question: 0,
          },
          {
            depends_on_choice: 1,
            depends_on_question: 1,
          },
          {
            depends_on_choice: 1,
            depends_on_question: 2,
          },
        ],
        question_text: "Will the affected tree be native or exotic?",
        allow_multiple: false,
        join_text_with: null,
        text_field_lines: null,
        question_subtitle: null,
        text_field_placeholder: null,
      },
    ],
    image_alt_text: "Your property image",
    question_title:
      "There are several trees visible within the property boundary, particularly along the rear and side boundaries of the lot.",
    next_button_label: "Continue",
    question_subtitle: null,
  },
};

export const getQuestion = (
  conversationId: string,
  messageNumber: number,
  messageType: string,
  questionData: object,
) => {
  return {
    id: crypto.randomUUID(),
    sender_account: "conversation_assistant_acccount@localhost.com",
    sender_account_id: "c48e151b-8ae4-4969-9ab8-8bd8954cada4",
    sender_account_type: "ASSISTANT",
    sender_account_first_name: "",
    sender_account_last_name: "",
    sender: "630b514b-86a1-443b-bcf1-5edb99eddd3a",
    conversation_id: conversationId || "",
    message_number: messageNumber,
    conversation_phase: "in_progress",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    is_deleted: false,
    message_type: messageType,
    text: "What are you planning to do?",
    status: "SEND",
    number: messageNumber,
    conversation: conversationId || "",
    question_data: questionData,
  };
};
